import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from '@material-ui/core';
import cx from 'clsx';
import { QAHeader } from './QAHeader';
export function Question(_a) {
    var q = _a.q, info = _a.info;
    return (_jsx(QAHeader, { title: q, titleClass: "faq-answer-title", avatar: _jsx(Avatar, { "aria-label": "Question", className: cx('faq-answer-q'), children: info ? '!' : 'Q' }) }));
}
//# sourceMappingURL=Question.js.map